import { Link } from "react-router-dom"

import MainLayout from "@/components/layout/MainLayout"

import HeroSection from "@/components/sections/HeroSection"
import ResultsSection from "@/components/sections/ResultsSection"
import ContactSection from "@/components/sections/ContactSection"

import TreatmentConfigurator from "@/components/configurator/TreatmentConfigurator"

export default function HomePage() {

  return (

    <MainLayout>

      <HeroSection />

      <ResultsSection />

      <TreatmentConfigurator />

      {/* GALLERY PREVIEW */}

      <section className="py-32 bg-[#f8f5f1] px-6">

        <div className="max-w-7xl mx-auto">

          <div className="text-center mb-20">

            <h2 className="text-4xl font-serif mb-4">
              Il nostro centro
            </h2>

            <p className="text-gray-500">
              Ambienti, trattamenti e risultati di Alkimya Estetica
            </p>

          </div>

          <div className="grid md:grid-cols-3 gap-6 items-center">

            <div className="overflow-hidden rounded-2xl h-[420px]">

              <img
                src="/images/gallery/gallery1.jpg"
                className="w-full h-full object-cover hover:scale-110 transition duration-700"
              />

            </div>

            <div className="overflow-hidden rounded-2xl h-[520px]">

              <img
                src="/images/gallery/gallery2.jpg"
                className="w-full h-full object-cover hover:scale-110 transition duration-700"
              />

            </div>

            <div className="overflow-hidden rounded-2xl h-[420px]">

              <img
                src="/images/gallery/gallery3.jpg"
                className="w-full h-full object-cover hover:scale-110 transition duration-700"
              />

            </div>

          </div>

          <div className="text-center mt-16">

            <Link
              to="/gallery"
              className="inline-flex items-center gap-3
                         px-10 py-4
                         rounded-full
                         bg-black text-white
                         hover:scale-105 transition"
            >
              Scopri tutta la gallery
            </Link>

          </div>

        </div>

      </section>

      <ContactSection />

    </MainLayout>

  )

}